import * as cx from 'classnames';
import Application from 'mk2/containers/Application/Application';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import { AppState, getRequestUser } from 'mk2/reducers';
import { routes } from 'mk2/router';
import { UserEntity } from 'mk2/schemas';
import 'mk2/styles/globals.scss';
import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import styles from './ForumApp.mscss';

interface OwnProps {

}

interface StateProps {
    requestUser: UserEntity;
}

interface DispatchProps {

}

type RouteProps = RouteComponentProps<{}>;
type Props = OwnProps & StateProps & DispatchProps & RouteProps;

class ForumApp extends React.Component<Props> {

    public render() {
        return (
            <Application routes={routes}>
                {({ app, content, rightContent, halfpage }) => (
                    <div className={cx(styles.ForumApp, styles[`ForumApp--${app}`])}>
                        <div className={cx(styles.ForumApp__content, styles[`ForumApp__content--${app}`])}>
                            {content}
                        </div>
                        {(app === 'forum' || app === 'strollers' || app === 'wiki' || app === 'home' || app === 'blogs') && (
                            <div className={cx(styles.ForumApp__rightContent, styles[`ForumApp__rightContent--${app}`])}>
                                {rightContent}
                                {halfpage && (
                                    <div className={cx(styles.ForumApp__ad, styles[`ForumApp__ad--${app}`])}>
                                       {halfpage}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                )}
            </Application>
        );
    }

}

function mapStateToProps(state: AppState, ownProps: RouteProps): StateProps {
    return {
        requestUser: getRequestUser(state),
    };
}

const mapDispatchToProps: MapDispatchToPropsObject<DispatchProps> = {

};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ForumApp));
